import { useState } from 'react';
import { Box, Container, Typography, Stack, DownloadButtons } from 'src/components';
import { DesktopProfileModal } from 'src/pages/profile';
import { useIsMobile } from 'src/hooks';

import heroImg from 'src/assets/home-hero.jpg';

const Hero = () => {
  const isMobile = useIsMobile();

  const [displayLogin, setDisplayLogin] = useState(false);

  return (<>
    <Box
      sx={{
        height: 'calc(100vh + 60px)',
        backgroundImage: `url(${heroImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        color: 'white',
      }}
    >
      {/* Optional overlay for better contrast */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          bgcolor: 'rgba(0, 0, 0, 0.3)',
          zIndex: 1,
          borderBottomLeftRadius: 30,
          borderBottomRightRadius: 30,
        }}
      />

      <Container
        sx={{
          height: '100%',
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pt: { xs: 4, sm: 8 } // Moves content slightly down
        }}
      >
        <Stack alignItems="center" textAlign="center" maxWidth="500px">
          <Typography
            variant="h1"
            sx={{
              color: 'white',
              fontFamily: '"Inter", "Helvetica Neue", -apple-system, BlinkMacSystemFont, sans-serif',
              fontWeight: 700,
              fontSize: {
                xs: '2.3rem',
                sm: '3.5rem',
              },
              lineHeight: 1.2,
              letterSpacing: '-0.01em',
              textShadow: '0px 4px 10px rgba(0, 0, 0, 0.6)',
            }}
          >
            Discover the Pan American Highway
          </Typography>

          <Typography
            variant="h5"
            fontWeight={isMobile ? 500 : 600}
            mt={2}
            sx={{
              maxWidth: '500px',
              textShadow: '0px 2px 6px rgba(0, 0, 0, 0.4)',
            }}
          >
            Track your journey, meet travelers, and discover hidden gems along the Pan-American Highway.
          </Typography>

          <DownloadButtons />

        </Stack>
      </Container>

      <Box sx={{ 
        position: "absolute", 
        bottom: -1, 
        left: 0, 
        right: 0, 
        lineHeight: 0,
        zIndex: 1 
      }}>
        <svg viewBox="0 0 1440 150" preserveAspectRatio="none" style={{ width: '100%', height: 80 }}>
          <path
            d="M0,50 C360,120 1080,120 1440,50 L1440,150 L0,150 Z"
            fill="#FAFAFA"
          />
        </svg>
      </Box>
    </Box>

    <DesktopProfileModal displayLogin={displayLogin} setDisplayLogin={setDisplayLogin}/>
  </>);
};

export default Hero;
